export default {
  SET_INTEGRATION_SETTINGS: '@WS/INTEGRATION/SET_SETTINGS',
};
